<div class="m-message-box" [class]="type">
  <p [innerHTML]="text"></p>
  <button aria-label="Fermer" title="Fermer" class="webfont webfont-close" (click)="close()"></button>
  </div>
